import { render, staticRenderFns } from "./QuestionarioDoc.vue?vue&type=template&id=d438bf52&"
import script from "./QuestionarioDoc.vue?vue&type=script&lang=ts&"
export * from "./QuestionarioDoc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports